import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import drawer from './drawer';
import filters from './filters';
import tool from './tool';
import cart from './cart';
import checkout from './checkout';
import auth from './auth';
import session from './session';

Swiper.use( [ Navigation ] );

function whenVisible( element, init ) {

    if ( ! element ) return;

    if ( ! ( 'IntersectionObserver' in window ) ) return init();

    const observer = new IntersectionObserver( ( entries ) => {
        if ( ! entries.some( ( entry ) => entry.isIntersecting ) ) return;
        observer.disconnect();
        init();
    }, { rootMargin: '200px' } );

    observer.observe( element );

}

jQuery(document).ready(function ($) {

    drawer();
    filters();
    tool();
    cart();
    checkout();
    auth();
    session();

    let scrollThreshold = null;

    jQuery(document).on('scroll', function () {
        scrollThreshold ??= 15 + jQuery('.header__main').outerHeight();

        if (jQuery(window).scrollTop() >= scrollThreshold) {
            jQuery('.header').addClass('is-scrolled');
        } else if (jQuery(window).scrollTop() < (scrollThreshold - 25)) {
            jQuery('.header').removeClass('is-scrolled');
        }
    });

    jQuery('.swiper-items').each(function () {
        const element = this;
        const $parent = $(element).closest('.swiper-main');

        whenVisible( element, () => new Swiper(element, {
            slidesPerView: 1.5,
            spaceBetween: 24,
            navigation: {
                nextEl: $parent.find('.swiper-controls-right')[0],
                prevEl: $parent.find('.swiper-controls-left')[0],
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
        }) );
    });

    document.querySelectorAll('.swiper-gateways').forEach( ( element ) => whenVisible( element, () => new Swiper(element, {
        slidesPerView: 'auto',
        spaceBetween: 6,
    }) ) );

    const gallerySwiper = new Swiper('.swiper-thumbnails', {
        slidesPerView: 1,
        spaceBetween: 16,
    });

    jQuery('.wc__singleproduct-gallery-nav').on('click', '[data-slide]', function () {
        const index = jQuery(this).data('slide');
        if (gallerySwiper && gallerySwiper.slideTo) gallerySwiper.slideTo(index);
    });

    if (gallerySwiper && gallerySwiper.on) {
        gallerySwiper.on('slideChange', function () {
            jQuery('.wc__singleproduct-gallery-nav [data-slide]')
                .removeClass('is-active')
                .filter('[data-slide="' + gallerySwiper.activeIndex + '"]')
                .addClass('is-active');
        });
    }

    jQuery('.faq__item').on('click', 'summary', function (e) {
        e.preventDefault();
        const $item = $(this).parent();
        const $answer = $item.find('.faq__answer');
        const $svg = $item.find('svg');
        const isOpen = $item.prop('open');

        if (isOpen) {
            $answer.stop().animate({height: '0'}, 300, function () {
                $item.removeAttr('open');
            });

        } else {
            $item.attr('open', '');
            const height = $answer[0].scrollHeight;
            $answer.css('height', '0').stop().animate({height: height + 'px'}, 300);
        }

        $svg.toggleClass('is-active');

    });

    jQuery(document).on('click', '[data-action="toggle_popup_instructions"]', function () {
        jQuery('.wc__singleproduct-instructions, .overlay').toggleClass('is-open');
    });

    jQuery(document).on('click', '[data-action="toggle_popup_assembly"]', function () {
        jQuery('.wc__singleproduct-assembly, .overlay').toggleClass('is-open');
    });

    jQuery('.wc__singleproduct-information-description-btn').on('click', function () {
        const $btn = $(this);
        const $desc = $btn.prev('div');
        const $svg = $btn.find('svg');
        const $label = $btn.find('span');
        const isOpen = $btn.hasClass('is-active');

        if (isOpen) {
            $desc.stop().animate({height: '150px'}, 300);
            $label.text('Toon meer');
        } else {
            const height = $desc[0].scrollHeight;
            $desc.stop().animate({height: height + 'px'}, 300);
            $label.text('Toon minder');
        }

        $btn.toggleClass('is-active');
        $svg.toggleClass('is-active');
    });

});